/**
 * 商品リストにテンプレート処理用の追加パラメータを設定
 */
export const addServiceTemplateTableParams = (products) => {

  // ひとつ前のpackIndexを設定
  let prevPackIndex = ''
  const packIndexCountMap = {}
  for (let i = 0; i < products.length; i++) {
    products[i].prevPackIndex = prevPackIndex
    const packIndex = products[i].packIndex
    if (typeof packIndexCountMap[packIndex] === 'undefined') {
      packIndexCountMap[packIndex] = 0
    }
    packIndexCountMap[packIndex]++
    prevPackIndex = packIndex
  }

  // packIndexごとのデータ件数を設定
  for (let i = 0; i < products.length; i++) {
    const packIndex = products[i].packIndex
    products[i].count = packIndexCountMap[packIndex]
  }

  return products
}
